import axios from 'axios'
export default {
    install(Vue, options) {
        Vue.prototype.newsIsTop = function(isTop) {
            return function(a, b) {
                let value1 = a[isTop];
                let value2 = b[isTop];
                return value2 - value1;
            }
        }
        Vue.prototype.headAnimate = function() {
                let p = 0;
                let t = 0;
                $(window).scroll(function(e) {
                    p = $(this).scrollTop();
                    if (t <= p) { //向下滚
                        let topHright = $(window).scrollTop();
                        if (topHright > 120) {
                            $("#web_header").css({
                                "position": "fixed",
                            });

                        }
                    } else { //向上滚
                        let topHeight = $(window).scrollTop();
                        if (topHeight < 120) {
                            $("#web_header").css({
                                "position": "relative",
                                // "top": "-160px",
                            });
                            // setTimeout(function() {
                            //     $("#web_header").css({ "top": "0" })
                            // }, 350)
                        }

                    }
                    setTimeout(function() { t = p; }, 0);
                });
            },
            Vue.prototype.goBack = function() {
                $("body,html").animate({ scrollTop: 0 }, 500);
            },
            Vue.prototype.refreshPage = function() {
                window.location.reload();
            }
    }
}


// WEBPACK FOOTER //
// ./src/lib/common.js